import { preferStableObjectReference } from "./preferStableObjectReference";
/**
 * Keep a stable reference to an object if it is the same as the previous object.
 * @param previous
 * @param current
 * @returns
 */
export function preferStableObjectReferenceNullable(previous, current) {
    if (previous == null) {
        return current;
    }
    if (current == null) {
        return current;
    }
    return preferStableObjectReference(previous, current);
}
//# sourceMappingURL=preferStableObjectReferenceNullable.js.map